// Keep these in sync with App\Rules\SubdomainFormatRule.
export const SUBDOMAIN_MAX_LENGTH = 63

export const SUBDOMAIN_PATTERN = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/

// Lowercases and strips whitespace so casing/spacing mistakes never reach validation.
// Other invalid characters are left in place so the user sees why the value was rejected.
export function normaliseSubdomain (value) {
	if (typeof value !== 'string') {
		return value
	}

	return value.toLowerCase().replace(/\s+/g, '')
}

export function validateSubdomain (value) {
	if (typeof value !== 'string' || value === '') {
		return true
	}

	if (value.length > SUBDOMAIN_MAX_LENGTH) {
		return `Your domain name cannot be longer than ${SUBDOMAIN_MAX_LENGTH} characters.`
	}

	if (!SUBDOMAIN_PATTERN.test(value)) {
		return 'Your domain name can only contain lowercase letters, numbers and hyphens, '
			+ 'and must start and end with a letter or number.'
	}

	if (value.includes('--')) {
		return 'Your domain name cannot contain two hyphens in a row.'
	}

	return true
}
